<template>
  <span>
    <span class="shelf-id">{{label.substr(0,2)}}</span>
    <span class="space-id" :class="`space-id--${label.substr(2,1)}`">{{label.substr(2,2)}}</span>
  </span>
</template>

<script>
export default {
  props: ['label']
}
</script>

<style lang="scss" scoped>
.shelf-id {
  position: relative;
  overflow: hidden;
  padding: 0 0.25em;

  background: #222;
  border-radius: 5px;
  margin-right: -0.25em;

  color: #fff;
}

.space-id {
  overflow: hidden;
  padding: 0 0.25em 0 0.5em;

  border-radius: 5px;

  &--1 {
    background: #cfc;
  }

  &--2 {
    background: #ccf;
  }

  &--3 {
    background: #fcc;
  }

  &--4 {
    background: #cff;
  }

  &--5 {
    background: #fcf;
  }

  &--6 {
    background: #ffc;
  }
}
</style>